import storage from "./storage";
import * as serviceWorkerRegistration from "../../serviceWorkerRegistration";

const bustCache = (): void => {
  if ("caches" in window) {
    caches.keys().then((names) => {
      if (names.length) {
        names.map((name) => caches.delete(name));
        serviceWorkerRegistration.unregister();
      }
    });
    storage.set("version", process.env.REACT_APP_VERSION);
  }
};

export default bustCache;
